




































import { Vue, Component, Watch } from "vue-property-decorator";
import PageHeader from "@/components/PageHeader.vue";
import PerformanceTodayCard from "@/components/Dashboard/PerformanceTodayCard.vue";
import PerformanceWeekCard from "@/components/Dashboard/PerformanceWeekCard.vue";
import PerformanceOverviewCard from "@/components/Dashboard/PerformanceOverviewCard.vue";
import CallView from "@/components/Call/CallView.vue";
import LeaderBoard from "@/components/LeaderBoard.vue";
import UpcomingCallback from "@/components/UpcomingCallback.vue";
import { Getter, State } from "vuex-class";
import { CallMode, Features, User } from "@/types";
import { checkFeatureAccess } from "@/helpers/permissions";
import * as api from "@/lib/api";
import { getMetrics } from "@/lib/api";
import moment from "moment";
import { collections } from "@/configs/firebase";

@Component({
  components: {
    PageHeader,
    CallView,
    LeaderBoard,
    UpcomingCallback,
    PerformanceTodayCard,
    PerformanceWeekCard,
    PerformanceOverviewCard
  }
})
export default class Dashboard extends Vue {
  @Getter("callMode") callMode!: CallMode;
  @State("user") user!: User;
  @State("access") userAccess!: any;

  dashboardStats: any = {};
  loading: boolean = false;
  metricsFilter: { [key: string]: any } = {
    dates: [
      moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD")
    ],
    agent: null
  };
  metrics: any = [];
  agents: any[] = [];

  @Watch("callMode")
  onCallModeChange(value: string) {
    if (value !== "inCall") {
      this.loadDashboardStats();
    }
  }

  async mounted() {
    this.loadDashboardStats();
    if (this.user.email) {
      this.getAllMetrics();
    }

    const snap = await collections.user
      .where("roles", "array-contains", "closer")
      .get();

    this.agents = snap.docs.map((doc: any) => ({
      id: doc.id,
      ...doc.data()
    }));
  }

  get isAdmin() {
    return this.user.roles && this.user.roles.includes("admin");
  }

  get agentsEmails() {
    return this.agents.map(agent => agent.email);
  }

  async getAllMetrics() {
    const metrics = await Promise.all([
      this.loadMetrics("calls_qtd"),
      this.loadMetrics("5m_calls_qtd"),
      this.loadMetrics("on_holds_qtd"),
      this.loadMetrics("sales_qtd")
    ]);
    this.metrics = metrics;
  }

  get canViewLeaderBoard() {
    return checkFeatureAccess(Features.Leaderboard, {
      access: this.userAccess,
      roles: this.user.roles || []
    });
  }

  async loadDashboardStats() {
    try {
      this.loading = true;
      const { data } = await api.getDashboardStats(
        this.isAdmin ? { admin: true } : {}
      );
      this.dashboardStats = data;
      this.loading = false;
    } catch (error) {
      this.loading = false;
    }
  }

  cleanObject(obj: { [key: string]: any }) {
    const cleanObject = obj;
    for (var propName in cleanObject) {
      if (
        cleanObject[propName] === null ||
        cleanObject[propName] === undefined ||
        cleanObject[propName] === ""
      ) {
        delete cleanObject[propName];
      }
    }
    return cleanObject;
  }

  async loadMetrics(metric?: String) {
    try {
      this.loading = true;
      const start_date = this.metricsFilter.dates[0]
        ? moment.utc(this.metricsFilter.dates[0]).format("YYYY-MM-DDTHH:mm:ss")
        : "";

      const end_date = this.metricsFilter.dates[1]
        ? moment.utc(this.metricsFilter.dates[1]).format("YYYY-MM-DDTHH:mm:ss")
        : "";

      const query: { [key: string]: any } = {
        start_date,
        end_date,
        email: this.metricsFilter.agent,
        metric: metric
      };

      if (this.metricsFilter.agent) {
        query.email = this.metricsFilter.agent;
        query.aggregate = false;
      } else {
        query.email = this.userEmail;
        query.aggregate = true;
      }

      const { data } = await getMetrics(this.cleanObject(query));
      this.loading = false;
      return data.value;
      // return { ...data, key: metric };
    } catch (err) {
      // @ts-ignore
      if (err.response.data.error) {
        this.loading = false;
        this.$toasted.error(err.response.data.error).goAway(2000);
      } else {
        this.loading = false;
        this.$toasted.error("Lead lookup error").goAway(2000);
      }
    }
  }

  get closerAgents() {
    /**
     * return this.agents.filter(
      agent => agent.groups && agent.groups.includes("fronter_t1")
    );
     */
    return this.agents;
  }

  get userEmail() {
    return this.user.email;
  }
}
